import React from "react";
import ReactApexChart from "react-apexcharts";

const defaultFormatter = (val) => {
  if (val === null || val === undefined) return "";
  return parseFloat(val.toFixed(2)).toLocaleString();
};

const MultipleColumnBarGraph = ({
  title,
  categories,
  seriesData,
  yAxisLeftConfig,
  yAxisRightConfig,
  colors,
  xAxisLabel,
  yAxisLabel,
  // ---- NEW optional props (all default to ORIGINAL behavior, so other usages are unaffected) ----
  columnWidth = "40%",
  dataLabelsFontSize = "10px",
  dataLabelsOffsetY = -20,
  dataLabelsFormatter = defaultFormatter,
  gridPaddingTop = 0,
  responsiveColumnWidths = { 1280: "55%", 768: "65%", 480: "75%" },
  strokeWidth = 4,
  xAxisBorderOffsetY = 1,
}) => {
  const chartOptions = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    title: {
      text: title,
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: 600,
      },
    },
    grid: {
      yaxis: { lines: { show: false } },
      xaxis: { lines: { show: false } },
      padding: {
        top: gridPaddingTop,
      },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    xaxis: {
      categories,
      axisBorder: { show: true, color: "#000", offsetY: xAxisBorderOffsetY },
      title: {
        text: xAxisLabel,
        style: { fontSize: "11px", color: "#000", fontWeight: "normal" },
      },
      labels: {
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
        trim: false,
        style: {
          fontSize: "10px",
          color: "#000",
          fontWeight: "normal",
        },
      },
    },
    yaxis: {
      axisTicks: { show: true },
      axisBorder: { show: true, color: "#000" },
      labels: {
        style: {
          fontSize: "12px",
          color: "#000",
          fontWeight: "normal",
        },
      },
      title: {
        text: yAxisLabel || yAxisLeftConfig.label,
        style: {
          fontSize: "12px",
          color: "#000",
          fontWeight: "normal",
        },
      },
      min: yAxisLeftConfig.min,
      max: yAxisLeftConfig.max,
      tickAmount: yAxisLeftConfig.tickAmount,
    },
    colors,
    dataLabels: {
      enabled: true,
      offsetY: dataLabelsOffsetY,
      style: {
        fontSize: dataLabelsFontSize,
        fontWeight: "normal",
        colors: ["#333"],
      },
      formatter: dataLabelsFormatter,
    },
    legend: {
      show: true,
      position: "right",
      fontSize: "12px",
      markers: {
        radius: 2,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth,
        distributed: false,
        dataLabels: {
          position: "top",
        },
      },
    },
    stroke: {
      show: strokeWidth > 0,
      width: strokeWidth,
      colors: ["transparent"],
    },
    responsive: [
      {
        breakpoint: 1280,
        options: {
          plotOptions: {
            bar: { columnWidth: responsiveColumnWidths[1280] },
          },
          chart: { height: 360 },
          xaxis: {
            labels: {
              rotate: 0,
              rotateAlways: false,
              hideOverlappingLabels: false,
              trim: false,
              style: { fontSize: "10px" },
            },
          },
          yaxis: {
            labels: {
              style: { fontSize: "11px" },
            },
          },
          legend: {
            fontSize: "11px",
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: { columnWidth: responsiveColumnWidths[768] },
          },
          chart: { height: 300 },
          xaxis: {
            labels: {
              rotate: 0,
              rotateAlways: false,
              hideOverlappingLabels: false,
              trim: false,
              style: { fontSize: "9px" },
            },
          },
          yaxis: {
            labels: {
              style: { fontSize: "10px" },
            },
          },
          legend: {
            position: "bottom",
            fontSize: "10px",
          },
        },
      },
      {
        breakpoint: 480,
        options: {
          plotOptions: {
            bar: { columnWidth: responsiveColumnWidths[480] },
          },
          chart: { height: 260 },
          xaxis: {
            labels: {
              rotate: 0,
              rotateAlways: false,
              hideOverlappingLabels: false,
              trim: false,
              style: { fontSize: "8px" },
            },
          },
          yaxis: {
            labels: {
              style: { fontSize: "9px" },
            },
          },
          legend: {
            position: "bottom",
            fontSize: "9px",
          },
        },
      },
    ],
  };

  return (
    <div className="w-full overflow-x-auto px-2 sm:px-4">
      <div className="min-w-[420px] sm:min-w-full">
        <ReactApexChart
          options={chartOptions}
          series={seriesData}
          type="bar"
          height={400}
        />
      </div>
    </div>
  );
};

export default MultipleColumnBarGraph;
